import {waitForBrowserOperation} from './browser-operation.js';

/** Drop only this application's offline shell; identity, drafts and outbox stay intact. */
export async function refreshApplicationAssets(): Promise<void> {
  if (!navigator.onLine) throw new Error('Для обновления подключитесь к интернету.');
  if ('serviceWorker' in navigator) {
    let registration: ServiceWorkerRegistration | undefined;
    try { registration = await waitForBrowserOperation(navigator.serviceWorker.getRegistration('/'), 'Браузер не ответил при проверке обновления. Перезапустите Chrome и повторите.'); }
    catch (error) {
      // Some browser documents cannot expose SW registrations. Refreshing the
      // owned shell and downloading current assets still works without one.
      if (!(error instanceof DOMException && error.name === 'InvalidStateError')) throw error;
    }
    if (registration) await waitForBrowserOperation(registration.update(), 'Обновление заняло слишком много времени. Повторите попытку.', 15_000);
  }
  if ('caches' in globalThis) {
    const names = await waitForBrowserOperation(caches.keys(), 'Кеш браузера не отвечает. Перезапустите Chrome и повторите.');
    await waitForBrowserOperation(Promise.all(names.filter(name => name.startsWith('pm-chat-shell-')).map(name => caches.delete(name))), 'Не удалось завершить очистку кеша. Перезапустите Chrome и повторите.');
  }
  // Reload the HTTP cache entries too. The next document carries stamped bundle URLs.
  for (const path of ['/', '/app.js', '/theme-init.js', '/styles.css']) {
    const response = await fetch(path, {cache:'reload', credentials:'same-origin', signal:AbortSignal.timeout(15_000)});
    if (!response.ok) throw new Error('Не удалось загрузить обновление. Повторите попытку.');
    await response.arrayBuffer();
  }
}
